import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './core/guards/auth.guard';

/**
 * Login sits outside the shell; every console route is lazy-loaded,
 * guarded behind sign-in, and rendered inside the authenticated shell.
 */
export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('./features/login/login.page').then((m) => m.LoginPage),
    title: 'Sign in · Zenoms',
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: 'catalog',
        loadComponent: () =>
          import('./features/catalog/catalog.page').then((m) => m.CatalogPage),
        title: 'Catalog · Zenoms',
      },
      {
        path: 'product/:id',
        loadComponent: () =>
          import('./features/catalog/product-detail.page').then((m) => m.ProductDetailPage),
        title: 'Product · Zenoms',
      },
      {
        path: 'cart',
        loadComponent: () => import('./features/cart/cart.page').then((m) => m.CartPage),
        title: 'Order review · Zenoms',
      },
      {
        path: 'order/success',
        loadComponent: () =>
          import('./features/order-success/order-success.page').then((m) => m.OrderSuccessPage),
        title: 'Order placed · Zenoms',
      },
      {
        path: 'orders',
        loadComponent: () => import('./features/orders/orders.page').then((m) => m.OrdersPage),
        title: 'Orders · Zenoms',
      },
      {
        path: 'inventory',
        loadComponent: () =>
          import('./features/inventory/inventory.page').then((m) => m.InventoryPage),
        title: 'Inventory · Zenoms',
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.page').then((m) => m.ProfilePage),
        title: 'Store · Zenoms',
      },
      { path: '', pathMatch: 'full', redirectTo: 'catalog' },
    ],
  },
  { path: '**', redirectTo: '' },
];
